<template>
  <div class="addMixedMode">
    <div class="status_1_content_Indexes">
      <ul>
        <template v-for="(item, index) in questionConfigure">
          <li
            v-if="item.extendOption.isIndexes"
            @click="handlescroll(item.sort)"
            :key="index"
            :title="item.extendOption.indexText"
          >
            <span class="el-icon-guide"></span>
            <span>
              {{ item.extendOption.indexText || '未命名' + (index + 1) }}
            </span>
          </li>
        </template>
      </ul>
    </div>

    <div style="flex: 1;display: flex;flex-direction: column;overflow: hidden;">

      <ul class="zlItCourseEdit_editor_tools">
        <li
          class="itemTool"
          v-for="(item, index) in option"
          :key="index"
          @click="addQuestionItem(item)"
          v-if="isShow(item)"
        >
          <svg
            style="width: 14px; height: 14px; vertical-align: -0.15em"
            class="icon svg-icon"
            aria-hidden="true"
          >
            <use :xlink:href="item.icon"></use>
          </svg>

          <span>{{ item.label }}</span>
        </li>
        <el-upload
          :action="importUrl"
          :headers="headers"
          accept=""
          :show-file-list="false"
          :on-progress="handleAvatarProgress"
          :on-success="handleAvatarSuccess"
          v-model="addImageText.value"
        >
          <li class="itemTool">
            <svg
              style="width: 14px; height: 14px; vertical-align: -0.15em"
              class="icon svg-icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-tianjiafujian1"></use>
            </svg>
            <span>附件</span>
          </li>
        </el-upload>

      </ul>

      <div class="zl_edit_box" @click="textImgVisible = false">
        <!--内容展示 -->
        <draggable
          v-if="questionConfigure && questionConfigure.length"
          chosenClass="chosen"
          class="zl_edit_content"
          :scroll="true"
          animation="200"
          v-model="questionConfigure"
          tag="div"
          :disabled="isImg"
        >
          <template v-for="(item, index) in questionConfigure">
            <div
              v-if="item"
              :ref="'scroll' + item.sort"
              :key="index + item.sort"
              :style="item.style"
              class="zl_edit_content_item"
              @click.stop="edit_content_focus(arguments[0], item, index)"
              @contextmenu.prevent="
                edit_content_contextmenu(arguments[0], item, index)
              "
            >
              <!-- 折叠框头部 -->
              <div class="zl_edit_collapse_header">
                <span style="display: inline-block;width: 65px;">
                  <svg
                    style="width: 15px; height: 15px; vertical-align: -0.08em"
                    class="icon svg-icon"
                    aria-hidden="true"
                  >
                    <use :xlink:href="courseIcon[item.type].icon"></use>
                  </svg>
                  <span class="logospan">{{ courseIcon[item.type].alt }}</span>
                </span>
                <tools
                  :myRef="'editor' + item.sort"
                  v-if="item.type === 1"
                  v-model="activeOne"
                  :class="{ showHeight: item.show }"
                ></tools>
                <div  style="display: flex;">
                  <div
                    class="zl_edit_collapse_btn"
                    @click="handleclickitem(item)"
                  >
                    <span
                      :class="{ xuanzhuan: item.show }"
                      class="el-icon-arrow-up buxuanzhuan"
                    ></span>
                  </div>
                  <div
                    class="zl_edit_collapse_btn"
                    @click="edit_content_contextmenu($event, item, index, 'click')"
                    >
                    <span class="el-icon-s-tools"></span>
                  </div>
                </div>
              </div>
              <!-- 图文内容 -->
              <div
                class="contentBox"
                :class="{ showHeight: item.show }"
                :style="{ textAlign: item.styleOption.textDecoration }"
              >
                <editor
                  v-if="item.type === 1"
                  :ref="'editor' + item.sort"
                  :myRef="'editor' + item.sort"
                  v-model="item.value"
                  height="500px"
                  :jyxStyle="courseId == 3156"
                ></editor>
                <div
                  v-if="item.type === 3"
                  class="ql-editor editorShowArea"
                  v-html="item.questionContent"
                ></div>
                <div class="lianjie" v-else-if="item.type === 5"><span @click="openlianjie(item)">{{item.name}}</span>
                </div>
                <img
                  v-else-if="item.type === 7"
                  :style="{
                    width: item.styleOption.width
                      ? item.styleOption.width + '%'
                      : '50%',
                  }"
                  class="zl_edit_content_img"
                  :src="item.value"
                />
                <video
                  v-else-if="item.type === 10"
                  class="video-js zl_edit_content_video"
                  :style="{ width: item.styleOption.width + '%' }"
                  controls
                  controlslist="nodownload"
                  preload="auto"
                  data-setup="{'example_option:true}"
                  :ref="'zl_edit_video' + index"
                >
                  <source
                    v-if="item.type == 10"
                    id="sourceBox"
                    :src="item.value"
                    type="video/mp4"
                    class="video"
                  />
                  <p class="vjs-no-js">不支持播放</p>
                </video>
                <code-compiler
                  :key="index"
                  :ref="'scroll' + item.sort"
                  v-else-if="item.type === 11"
                  image_text
                  v-model="item.value"
                ></code-compiler>
                <div class="lianjie" v-else-if="item.type === 12"> {{ item.name || item.value }}</div>
                <!-- pdf -->
                <iframe v-else-if="item.type == 110"
                  style="width: 100%;height: 450px;"
                  :src=" pptIframe + item.value"
                  frameborder="0"
                ></iframe>
              </div>
              <!-- 步骤展示 -->
              <div class="zl_edit_content_title" v-if="item.extendOption.isIndexes">
                <el-tooltip
                  effect="dark"
                  :content="item.extendOption.event?'步骤：'+ item.extendOption.indexText + '; 事项：' + item.extendOption.event : '步骤：'+ item.extendOption.indexText"
                  placement="top-start">
                  <span class="el-icon-guide"></span>
                </el-tooltip>
              </div>

              <div
                class="addMixedMode_right_dialog"
                :class="{ addMixedMode_right_dialog_show: textImgVisible && activeIndex === index }"
                @click.stop
              >
                <!-- 折叠框展开内容 -->
                <div class="create_image_text_popper2_cont">
                  <svg
                    v-if="textImgVisible"
                    style="width: 100px; height: 100px"
                    class="icon svg-icon"
                    aria-hidden="true"
                  >
                    <use :xlink:href="courseIcon[activeOne.type].icon"></use>
                  </svg>
                  <div
                    class="zl_drawer_body"
                    v-if="activeOne.extendOption && activeOne.styleOption"
                  >

                    <p class="zl_drawer_p">
                      <span class="zl_drawer_label">设置为步骤：</span>
                      <el-switch
                        v-model="activeOne.extendOption.isIndexes"
                        active-text="是"
                        inactive-text="否"
                        @change="isIndexesChange(activeOne.extendOption.isIndexes)"
                      ></el-switch>
                    </p>

                    <p class="zl_drawer_p">
                      <span class="zl_drawer_label">步骤名：</span>
                      <el-input
                        style="flex: 1"
                        size="mini"
                        :disabled="!activeOne.extendOption.isIndexes"
                        v-model="activeOne.extendOption.indexText"
                        @blur="indexTextChange(activeOne.extendOption.indexText)"
                        placeholder="请输入索引内容"
                      ></el-input>
                    </p>
                    <!--          <p class="zl_drawer_p">-->
                    <!--            <span class="zl_drawer_label">步骤关联事项：</span>-->
                    <!--            <el-button :disabled="!activeOne.extendOption.indexText" size="mini" type="primary" plain-->
                    <!--                       @click="handlerelationStepDrawer">-->
                    <!--              {{ activeOne.extendOption.event?activeOne.extendOption.eventName|| activeOne.extendOption.event:'选择' }}-->
                    <!--            </el-button>-->
                    <!--          </p>-->

                    <!-- 图片或视频独有的配置 -->
                    <template v-if="activeOne.type === 7 || activeOne.type === 10">
                      <p class="zl_drawer_p">
                        <span class="zl_drawer_label">宽度：</span>
                        <el-slider
                          size="mini"
                          style="flex: 1"
                          v-model="activeOne.styleOption.width"
                          show-stops
                        >
                        </el-slider>
                      </p>

                      <p class="zl_drawer_p">
                        <span class="zl_drawer_label">对齐方式：</span>
                        <el-select
                          size="mini"
                          style="flex: 1"
                          v-model="activeOne.styleOption.textDecoration"
                          placeholder="请选择"
                        >
                          <el-option label="左对齐" value="left"></el-option>
                          <el-option label="居中对齐" value="center"></el-option>
                          <el-option label="右对齐" value="right"></el-option>
                        </el-select>
                      </p>
                    </template>

                    <!-- 代码块独有的配置 -->
                    <template v-if="activeOne.type === 11 && !isStep">
                      <p class="zl_drawer_p">
                        <span class="zl_drawer_label">展示操作按钮：</span>
                        <el-switch
                          v-model="activeOne.extendOption.operationIsShow"
                          active-text="是"
                          inactive-text="否"
                        ></el-switch>
                      </p>

                      <p class="zl_drawer_p">
                        <span class="zl_drawer_label">代码生成文件：</span>
                        <el-switch
                          v-model="activeOne.extendOption.allCode"
                          active-text="是"
                          inactive-text="否"
                        ></el-switch>
                      </p>
                    </template>
                  </div>
                </div>
              </div>
            </div>


          </template>

          <vue-context-menu
            class="type6contextmenu"
            :contextMenuData="contextMenuData"
            @deletedata="deletedata"
            @editerdata="editerdata"
            @insertOne="insertOne"
            @setdata="setdata"
          ></vue-context-menu>
        </draggable>
        <div v-else class="kong">暂无内容</div>
      </div>

    </div>

    <el-drawer
      :visible.sync="drawer"
      size="66%"
      custom-class="addImageTextDialog"
      :with-header="false"
      destroy-on-close
      append-to-body
    >
      <div class="drawerHeader" style="font-size: 32px; font-weight: 600">
        {{ "添加" + addImageText.label }}
      </div>
      <div style="height: calc(100% - 125px)">
        <add-question
          v-if="addImageText.type === 3"
          v-model="addImageText.value"
          :subjectId="subjectId"
          :courseId="courseId"
          course
          qsType="3"
          resourcesFrom="1"
        ></add-question>
        <!--        <add-Paper-->
        <!--          v-else-if="addImageText.type === 5"-->
        <!--          course-->
        <!--          v-model="addImageText.value"-->
        <!--          :courseId="courseId"-->
        <!--          :subjectId="subjectId"-->
        <!--        ></add-Paper>-->
        <courseResourse
          v-else
          :nodeKey="nodeKey"
          v-model="addImageText.value"
          :subjectId="subjectId"
          :courseId="courseId"
          :type="addImageText.type"
          resourcesFrom="1"
          @hhdTeacher="getRow"
        ></courseResourse>
      </div>

      <div class="drawerFooter" style="text-align: center">
        <el-button size="small" @click="drawer = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addMixedModeSubmit"
        >确 定
        </el-button
        >
      </div>
    </el-drawer>

    <el-dialog
      title="请选择插入内容"
      :visible.sync="dialogVisible"
      width="400px"
      append-to-body
      custom-class="tobodydialog"
    >
      <ul>
        <li
          class="itemTool"
          v-for="(item, index) in option"
          :key="index"
          @click="addQuestionItem(item)"
          v-if="isShow(item)"
        >
          <svg
            style="width: 14px; height: 14px; vertical-align: -0.15em"
            class="icon svg-icon"
            aria-hidden="true"
          >
            <use :xlink:href="item.icon"></use>
          </svg>
          <span>{{ item.label }}</span>
        </li>
        <el-upload
          class="itemTool"
          style="width: calc(100% - 40px);"
          :action="importUrl"
          :headers="headers"
          accept=""
          :show-file-list="false"
          :on-progress="handleAvatarProgress"
          :on-success="handleAvatarSuccess"
          v-model="addImageText.value"
        >
          <li>
            <svg
              style="width: 14px; height: 14px; vertical-align: -0.15em"
              class="icon svg-icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-tianjiafujian1"></use>
            </svg>
            <span>附件</span>
          </li>
        </el-upload>
      </ul>
    </el-dialog>

  </div>
</template>

<script>
  import codeCompiler from "../../component/code_compiler";
  import courseResourse from "../../component/courseResourse";
  import addQuestion from "../../component/addQuestion";
  import addPaper from "../../component/addPaper";
  import status_1_content from "../../component/zlItCourseEdit_show_status_1_content"; // 内容展示
  import tools from "@/components/zl-editor/tools";
  import option from "../js/option";
  import editor from "@/components/zl-editor";
  import * as newCourseApi from "../../../api/newCourseApi";
  // import * as courseApi from "../../../api/courseApi";
  import draggable from "vuedraggable";
  import paperPreview from "../../component/paperPreview";
  // zl-drawer
  import zlPdf from "@/components/zl_pdf";

  export default {
    name: "addMixedMode",
    props: {
      value: {
        type: Array,
        default: () => [{}],
      },
      subjectId: {
        type: [String, Number],
        default: 0,
      },
      courseId: {
        type: [String, Number],
        default: 0,
      },
      questionId: {
        type: [String, Number],
        default: 0,
      },
      isStep: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      tools,
      codeCompiler,
      courseResourse,
      addQuestion,
      paperPreview,
      status_1_content,
      editor,
      // wEditor,
      draggable,
      addPaper,
      zlPdf
      // vEditor
    },
    data() {
      return {
        questionConfigure: this.value,
        drawer: false,
        isEditor: false, // 是修改吗？
        dialogVisible: false,
        option: option,
        nodeKey: "id",
        addImageText: {},
        activeOne: {}, // 选中的元素
        activeIndex: null, // 选中的元素
        insertIndex: null, // 选中的元素后插入一项
        // 菜单数据
        contextMenuData: {
          //菜单显示的位置
          axis: {
            x: null,
            y: null,
          },
          //菜单选项
          menulists: [],
        },
        courseIcon: {
          1: {
            icon: "#icon-wenben",
            alt: "文本",
          },
          3: {
            icon: "#icon-shiti",
            alt: "试题",
          },
          5: {
            icon: "#icon-link",
            alt: "链接",
          },
          7: {
            icon: "#icon-tupian",
            alt: "图片",
          },
          10: {
            icon: "#icon-shipin",
            alt: "视频",
          },
          11: {
            icon: "#icon-daima",
            alt: "代码",
          },
          12: {
            icon: "#icon-fujian1",
            alt: "附件",
          },
          110: {
            icon: "#icon-ppt",
            alt: "ppt",
          },
        },
        questionType: {
          1: "单选题",
          2: "多选题",
          3: "判断题",
          4: "判断题",
          5: "判断题",
          6: "判断题",
          7: "判断题",
          8: "判断题",
          9: "实操题",
        },
        textImgVisible: false,
        file: {
          label: "附件",
          type: 12,
          value: "",
          icon: "#icon-fujian1",
          style: "",
          sort: new Date().getTime(),
          name: "",
          styleOption: {},
          extendOption: {
            operationIsShow: false,
            isIndexes: false,
            allCode: false,
            indexText: "",
          },
        },
        importUrl: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`, // 上传各种文件的服务器地址
        isImg: false, // 如果选中富文本中的图片，禁止拖拽
        //
        // relationId: '', // 全局实训的关联试题id
        // answer: [], // 事项
        // relationQuestionDrawer: false,
        // relationStepDrawer: false,
        //
        // isHaveQuestion: false, // 是否有试题。
        // questionObj: {},
        pptIframe: process.env.PREVIEW_URL,
      };
    },
    computed: {
      headers() {
        return {
          Authorization: "bearer " + localStorage.getItem("Authorization"),
        };
      },
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            this.questionConfigure = val;
            // this.findQuestion();
          }
        },
        immediate: true,
        deep: true,
      },
      questionConfigure: {
        handler(val) {
          this.$emit("input", val);
        },
        immediate: true,
        deep: true,
      },
    },
    created() {

    },
    mounted() {
    },
    methods: {
      addQuestionItem(item) {
        let o = JSON.parse(JSON.stringify(item));
        o.sort = new Date().getTime();
        if (o.type === 1 || o.type === 11) {
          if (this.insertIndex > 0) {
            this.$set(o, "value", "");
            this.questionConfigure.splice(this.insertIndex, 0, o);
            this.insertIndex = -1;
          } else {
            this.questionConfigure.push(o);
            this.$nextTick(() => this.handlescroll(o.sort));
          }
          this.dialogVisible = false;
        } else {
          this.addImageText = o;
          if (o.type === 5 || o.type === 7 || o.type === 10 || o.type === 110) {
            this.nodeKey = "url";
          } else {
            this.nodeKey = "id";
          }
          this.drawer = true;
        }
      },
      /* 在课程里编辑多步骤实操题时，不再添加试题 */
      isShow(o) {
        if (o.type === 3 && this.isStep) {
          return false;
        } else {
          return true;
        }
      },
      isIndexesChange(val) {
        if (!val) {
          this.$set(this.activeOne.extendOption, 'indexText', '');
          this.$set(this.activeOne.extendOption, 'event', '');
        }
      },
      indexTextChange(val) {
        if (!val) {
          this.$set(this.activeOne.extendOption, 'event', '');
        }
      },
      edit_content_focus(e, item, index) {
        this.textImgVisible = false;
        this.activeOne = item;
        this.activeIndex = index;
        if (e.path && e.path.length) {
          // 如果选中的是图片，禁止拖拽内容
          if (e.path[0].nodeName == "IMG") {
            this.isImg = true;
          } else {
            this.isImg = false;
          }
        }
      },

      edit_content_contextmenu(e, item, index, trigger) {

        this.textImgVisible = false;
        this.activeOne = item;
        this.activeIndex = index;
        let menulists = [];
        if (item.type === 1 || item.type === 11) {
          menulists = [
            {
              fnHandler: "setdata",
              icoName: "el-icon-setting",
              btnName: "设 置",
            },
            {
              fnHandler: "insertOne",
              icoName: "el-icon-zoom-in",
              btnName: "向下插入一项",
            },
            {
              fnHandler: "deletedata",
              icoName: "el-icon-delete",
              btnName: "删 除",
            },
          ];
        } else {
          menulists = [
            {
              fnHandler: "setdata",
              icoName: "el-icon-setting",
              btnName: "设 置",
            },
            {
              fnHandler: "editerdata",
              icoName: "el-icon-brush",
              btnName: "修 改",
            },
            {
              fnHandler: "insertOne",
              icoName: "el-icon-zoom-in",
              btnName: "向下插入一项",
            },
            {
              fnHandler: "deletedata",
              icoName: "el-icon-delete",
              btnName: "删 除",
            },
          ];
        }
        this.$set(this.contextMenuData, "menulists", menulists);

        let availableHeight = window.innerHeight - 160;  // 定位的可用高度，不能超出屏幕下面

        if (trigger === 'click'){
          this.contextMenuData.axis = {
            x: e.clientX - 200,
            y: e.clientY + 50 > availableHeight ? availableHeight : e.clientY + 50,
          };
        }else{
          this.contextMenuData.axis = {
            x: e.clientX,
            y: e.clientY > availableHeight ? availableHeight: e.clientY ,
          };
        }
      },
      handleclickitem(o) {
        if (o.show) {
          this.$set(o, "show", false);
        } else {
          this.$set(o, "show", true);
        }
      },
      addMixedModeSubmit() {
        let addItem = JSON.parse(JSON.stringify(this.addImageText));
        addItem['sort'] = new Date().getTime();
        if (!addItem.value) return;
        if (addItem.type == 3) {
          this.getMaterial(addItem.value);
        } else {
          if (this.isEditor) {
            this.questionConfigure.splice(this.activeIndex, 1, addItem);
            this.isEditor = false;
          } else {
            if (this.insertIndex > 0) {
              this.questionConfigure.splice(this.insertIndex, 0, addItem);
              this.insertIndex = -1;
            } else {
              this.questionConfigure.push(addItem);
              this.$nextTick(() => this.handlescroll(addItem.sort));
            }
          }
        }
        this.dialogVisible = false;
        this.drawer = false;
      },
      getRow(row) {
        this.$set(this.addImageText, 'name', row.name)
      },
      openlianjie(item) {
        if (item.value) {
          window.open(item.value, '_blank');
        } else {
          this.$messageWarning('配置有误，请仔细检查')
        }
      },
      //试题详情
      getMaterial(id) {
        newCourseApi
          .QueryQuestionById(id)
          .then((res) => {
            if (res.code === "0") {
              if (res.data && res.data.questionContent) {
                this.$set(
                  this.addImageText,
                  "questionContent",
                  res.data.questionContent
                );
                this.$set(
                  this.addImageText,
                  "questionTypeId",
                  res.data.internalTypeId
                );
                if (this.isEditor) {
                  this.questionConfigure.splice(
                    this.activeIndex,
                    1,
                    this.addImageText
                  );
                  this.isEditor = false;
                } else {
                  if (this.insertIndex > 0) {
                    this.questionConfigure.splice(
                      this.insertIndex,
                      0,
                      this.addImageText
                    );
                    this.insertIndex = -1;
                  } else {
                    this.questionConfigure.push(this.addImageText);
                    this.$nextTick(() =>
                      this.handlescroll(this.addImageText.sort)
                    );
                  }
                }
              }
            } else {
              return this.$message({
                type: "warning",
                message: res.msg,
              });
            }
          })
          .finally(() => {
            this.dialogVisible = false;
          });
      },
      editerdata() {
        this.addImageText = this.activeOne;
        if (this.addImageText.type === 5 || this.addImageText.type === 7 || this.addImageText.type === 10 || this.addImageText.type === 110) {
          this.nodeKey = "url";
        } else {
          this.nodeKey = "id";
        }
        this.drawer = true;
        this.isEditor = true; // 修改标识
      },
      // 在选中的位置插入一项
      insertOne() {
        if (this.activeIndex > -1) {
          this.insertIndex = this.activeIndex + 1;
          this.dialogVisible = true;
        }
      },
      setdata() {
        this.textImgVisible = true;
      },
      // 删除图文中的某一项
      deletedata() {
        this.questionConfigure.splice(this.activeIndex, 1);
        this.activeIndex = -1;
      },
      //上传图片
      handleAvatarSuccess(res) {
        if (res.code == 0) {
          this.addImageText = {
            label: "附件",
            type: 12,
            value: res.data.originalAttaUrl,
            icon: "#icon-fujian1",
            style: "",
            sort: new Date().getTime(),
            name: res.data.name,
            styleOption: {},
            extendOption: {
              operationIsShow: false,
              isIndexes: false,
              allCode: false,
              indexText: "",
            },
          };

          if (this.insertIndex > 0) {
            this.questionConfigure.splice(
              this.insertIndex,
              0,
              JSON.parse(JSON.stringify(this.addImageText))
            );
            this.insertIndex = -1;
          } else {
            this.questionConfigure.push(JSON.parse(JSON.stringify(this.addImageText)));
            this.$nextTick(() =>
              this.handlescroll(this.addImageText.sort)
            );
          }
        } else {
          this.$messageWarning(res.msg);
        }
        this.dialogVisible = false;
      },
      handleAvatarProgress() {
        this.addImageText.value = "";
      },
      // handleEventClick(item) {
      //   if (this.activeOne.extendOption.event == item.timestamp) {
      //     this.$set(this.activeOne.extendOption, 'event', 0);
      //     this.$set(this.activeOne.extendOption, 'eventName', '');
      //   } else {
      //     this.$set(this.activeOne.extendOption, 'event', item.timestamp);
      //     this.$set(this.activeOne.extendOption, 'eventName', item.value.stepName || (item.sort + 1) + item.eventName);
      //   }
      // },
      allowDrop(draggingNode, dropNode, type) {
        // 排序筛选的拖拽。 Author by wjl. on 2021.4.13
        return type !== "inner";
      },
      // 点击导航菜单，页面滚动到指定位置
      handlescroll(index) {
        if (
          eval("this.$refs.scroll" + index) &&
          eval("this.$refs.scroll" + index).length
        ) {
          let length = eval("this.$refs.scroll" + index).length;
          eval("this.$refs.scroll" + index)[length - 1].scrollIntoView({
            behavior: "smooth", // 平滑过渡
            // block: "center", // 上边框与视窗顶部平齐。默认值
          });
          this.activeIndex = index;
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  .addMixedMode {
    position: relative;
    display: flex;
    min-height: 500px;

    .zlItCourseEdit_editor_tools {
      position: sticky;
      top: 0;
      z-index: 1000;
      background: #ffffff;
      padding-left: 10px;
      display: flex;
      justify-content: center;
    }

    .itemTool {
      height: 28px;
      line-height: 28px;
      padding: 1px 15px;
      margin-right: 10px;
      margin-top: 5px;
      margin-bottom: 5px;
      font-size: 12px;
      cursor: pointer;
      background: #ededf0;
      border-radius: 4px;

      &:hover {
        background: linear-gradient(
            135deg,
            #1890ff 0%,
            #00b3f7 100%,
            #00b3f7 100%
        );
        color: #ffffff;

        svg {
          fill: #ffffff;
        }
      }
    }

    .isrelation {
      background: linear-gradient(
          135deg,
          #1890ff 0%,
          #00b3f7 100%,
          #00b3f7 100%
      );
      color: #ffffff;

      svg {
        fill: #ffffff;
      }
    }

    .zl_edit_box {
      padding: 5px 20px;
      background: #ffffff;
      flex: 1;
      position: relative;
      overflow: auto;
      /* 展示框内容的样式 */
      .zl_edit_content {
        position: relative;
      }

      .zl_edit_collapse_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 28px;
        padding: 10px;
        background-color: #f5f5f7;

        .zl_edit_collapse_isShow {
          cursor: pointer;
        }

        .logospan {
          font-family: PingFangSC-Medium, PingFang SC;
          color: #0f0d11;
          font-size: 14px;
        }
      }

      .zl_edit_collapse_btn {
        border-radius: 3px;
        background-color: #dce0e9;
        width: 20px;
        height: 20px;
        line-height: 16px;
        cursor: pointer;
        margin: 0 2px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .zl_edit_content_item {
        width: 99%;
        margin: 10px auto;
        display: block;
        cursor: move;
        border-radius: 4px;
        position: relative;
      }

      .zl_edit_content_title {
        position: absolute;
        left: -24px;
        top: 0px;

        .el-icon-guide {
          color: #1890FF;
          cursor: pointer;
        }
      }

      .zl_edit_content_img,
      .zl_edit_content_video {
        display: inline-block;
        height: 100%;
        max-width: 100%;
      }

      .contentBox {
        max-height: 600px;
        overflow: auto;
        transition: all 0.3s ease;
        background: rgba(245, 245, 247, 0.3);
      }

      /* 改变高度 */
      .showHeight {
        min-height: 0;
        max-height: 0;
        overflow: hidden;
        transition: all 0.3s ease;
      }

      .buxuanzhuan {
        transition: all 0.3s ease;
        transform: rotate(0deg);
        font-size: 11px;
        font-weight: 600;
      }

      /* 旋转 */
      .xuanzhuan {
        transform: rotate(180deg);
      }


      .lianjie {
        padding: 12px 15px;

        span {
          text-decoration: underline;
          color: blue;
          cursor: pointer;
        }
      }


      /*.chosen {*/
      /*  background-color: #a0cfff !important;*/
      /*}*/

      /* 获取焦点，展示虚点框框 */
      /*.focusItem {*/
      /*  !*border: 2px #0e9aff dashed !important;*!*/
      /*}*/
    }

    .addMixedMode_right_dialog {
      position: absolute;
      right: 3px;
      top: 3px;
      height: 100%;
      min-height: 300px;
      width: 0px;
      transition: all, 0.3s ease;
      overflow-y: auto;
      background: #ffffff;
      box-shadow: -3px 2px 5px #cccccc;
      z-index: 200;
      border-radius: 5px;
    }

    .addMixedMode_right_dialog_show {
      transition: all, 0.3s ease;
      width: 300px;
    }

    /*.el-button {*/
    /*  background: #2b2a33;*/
    /*  !*border-color: #2b2a33;*!*/
    /*  color: #ffffff;*/
    /*}*/

    .drawerHeader,
    .drawerFooter {
      height: 60px;
      line-height: 60px;
    }

    .kong {
      padding-top: 30%;
      text-align: center;
      color: #666666;
    }
  }

  .zl_drawer_body {
    padding: 15px;

    .zl_drawer_p {
      display: flex;
      align-items: center;

      .zl_drawer_label {
        text-align: right;
        width: 120px;
        margin-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 38px;
      }
    }

    .el-radio-group {
      display: flex;
      align-items: center;
    }

    .el-radio {
      margin-right: 10px;
    }
  }

  .status_1_content_Indexes {
    padding-top: 60px;

    ul {
      li {
        width: 130px;
        height: 40px;
        line-height: 40px;
        list-style: none;
        font-size: 13px;
        font-weight: 500;
        color: #303133;
        cursor: pointer;
        overflow: hidden; //超出部分隐藏
        white-space: nowrap; //不换行
        text-overflow: ellipsis; //文字超出部分用省略号表示
      }

      .active {
        color: #409EFF;
      }
    }
  }
</style>

<style lang="scss">
  .tobodydialog {
    .itemTool {
      line-height: 28px;
      padding: 1px 15px;
      margin-right: 10px;
      margin-top: 5px;
      margin-bottom: 5px;
      font-size: 12px;
      cursor: pointer;
      background: #ededf0;
      border-radius: 4px;

      &:hover {
        background: linear-gradient(
            135deg,
            #1890ff 0%,
            #00b3f7 100%,
            #00b3f7 100%
        );
        color: #ffffff;

        svg {
          fill: #ffffff;
        }
      }
      .el-upload{
        width: 100%;
        text-align: left;
      }
    }
  }
</style>

<style>
  .addImageTextDialog .el-drawer__body,
  .zlItCourseEdit_drawer .el-drawer__body {
    padding: 0px 20px 20px;
    overflow: auto;
  }

  .addMixedMode .el-collapse-item__header {
    height: 40px;
    background: #f5f5f7;
  }

  .addMixedMode .el-collapse-item__wrap {
    border: 0;
  }

  .addMixedMode .el-collapse-item__content {
    padding: 0;
    line-height: inherit;
  }

  .type6contextmenu {
    width: 180px;
    padding: 10px;
    border: solid 1px #e5e5e5;
  }

  .type6contextmenu .context-menu-list {
    background-color: #ededed !important;
    padding-left: 10px !important;
    height: 30px;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-radius: 4px;
    margin: 10px 0 !important;
  }
  .type6contextmenu .context-menu-list:hover{
    background-color: #409EFF !important;
    color: #ffffff;
  }

  .type6contextmenu .nav-icon-fontawe {
    color: #666666 !important;
  }

  .type6contextmenu .context-menu-list:hover .nav-icon-fontawe{
    color: #ffffff !important;
  }

  .create_image_text_popper2_cont {
    padding: 10px;
    text-align: center;
  }

  .create_image_text_popper2_cont img {
    width: 60px;
    height: 60px;
    display: block;
    margin: 10px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/single_resource_course/components/addMixedMode.vue